<template>
  <div :class="['w-100', 'wrap', disabled ? 'disabled' : '']">
    <label v-for="(item, index) in radioList" :key="index" class="item">
      <input class="radio" type="radio" :value="item.value" v-model="picked" style="display: none" />
      {{ item.label }}
      <div></div>
    </label>
  </div>
</template>
<script>
export default {
  name: 'cus-radio',
  props: {
    radioList: { type: Array },
    selectValue: { type: [String, Boolean], default: null },
    disabled: { type: Boolean, default: false },
  },
  computed: {
    picked: {
      get() {
        return this.selectValue;
      },
      set(val) {
        this.$emit('update:selectValue', val);
      },
    },
  },
  data() {
    return {};
  },
};
</script>
<style lang="scss" scoped>
.wrap {
  display: flex;
  justify-content: space-between;
}
.item {
  color: $color-blue;
  font-size: 2.2rem;
  cursor: pointer;
  padding-left: 35px;
  position: relative;
  &::before {
    content: '';
    position: absolute;
    width: 20px;
    height: 20px;
    border: 2px solid $color-blue;
    border-radius: 50%;
    left: 0;
    top: 50%;
    transform: translateY(-45%);
  }
  input:checked + div::after {
    content: '';
    position: absolute;
    width: 12px;
    height: 12px;
    background-color: $color-blue;
    border-radius: 50%;
    left: 4px;
    top: 50%;
    transform: translateY(-44%);
  }
}
.disabled {
  .item {
    cursor: not-allowed;
    opacity: 0.6;
    pointer-events: none;
  }
}
</style>
